export const addNotification = (notification) => ({
  type: 'addNotification',
  notification,
});
export const removeNotification = (id) => ({ type: 'removeNotification', id });
